module.exports = __webpack_public_path__ + "static/img/vipbgc.7790e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/vipbgc.png
// module id = AlyD
// module chunks = 1